import React from 'react';
import classes from './AlertDialog.module.css'

import { useNavigate } from 'react-router-dom';
import { IoClose, IoCloseOutline } from 'react-icons/io5';
import { useTheme } from '../../../context/ThemeContext';
import useWindowDimensions from '../../../hooks/getWindowDimensions';
import CommonCard from '../CommonCard/CommonCard';





const AlertDialog = ({ isOpen, toggleSidebar, children, titleText, onClose, centerCard, cardClass, showToSection=true, showCloseIcon, style}) => {
    const navigate = useNavigate();
    const {darkMode} = useTheme()

    const { height, width } = useWindowDimensions();

    return (
      <>
        {isOpen && <div className={classes.overlay} onClick={toggleSidebar}></div>}
        <CommonCard className={`${centerCard && classes.centerCard} ${ width > 767 ? classes.dialogBox : classes.mobileDialogBox} ${isOpen ? classes.open : ''} ${cardClass} `} style={style}>
            {showToSection && <div className={`d-flex align-items-center justify-content-between ${classes.topSection}`}><div><h3>{titleText}</h3></div>{showCloseIcon && <IoCloseOutline size={30} role='button' onClick={onClose}/>}</div>}
            {children}
        </CommonCard>
      </>
    );
  };
  
  export default AlertDialog;